import type { As400NumberFormat } from '@erp/rpc';
import { numberFormatProblem } from '@erp/item-master-rules';

export function as400ReviewGridColumnClassName(
  formats: ReadonlyMap<string, As400NumberFormat>,
  editKey: string | null,
): 'htRight' | undefined {
  return editKey !== null && formats.has(editKey) ? 'htRight' : undefined;
}

export function padAs400NumberDisplay(
  value: string | null,
  format: As400NumberFormat | undefined,
  keepWhitespace = false,
): string | null {
  if (
    value === null ||
    value === '' ||
    format === undefined ||
    keepWhitespace ||
    format.fractionDigits === 0
  ) {
    return value;
  }
  if (format.clearValues?.includes(value)) return value;
  if (numberFormatProblem(value, format) !== null) return value;
  const point = value.indexOf('.');
  const whole = point === -1 ? value : value.slice(0, point);
  const fraction = point === -1 ? '' : value.slice(point + 1);
  return `${whole}.${fraction.padEnd(format.fractionDigits, '0')}`;
}

export function applyAs400NumberDisplay(
  td: { textContent: string | null },
  text: string | null,
  format: As400NumberFormat | undefined,
  keepWhitespace = false,
): void {
  const display = padAs400NumberDisplay(text, format, keepWhitespace);
  if (display !== null && display !== text) {
    td.textContent = display;
  }
}

export function as400NumberFormatForProp(
  formats: ReadonlyMap<string, As400NumberFormat>,
  prop: string | number,
): As400NumberFormat | undefined {
  return typeof prop === 'string' ? formats.get(prop) : undefined;
}
